export default __webpack_public_path__ + "static/media/search.0d45e417.svg";